<template>
  <div>
    <van-popup v-model="show" position="right" style="height: 100%; width: 80%">
      <div class="btn-wrap">
        <div class="pop-title">
          <p>搜索筛选区</p>
          <van-icon name="cross" @click="cancel" />
        </div>
        <div class="select_list">
          <van-collapse v-model="activeNames" accordion>
            <van-collapse-item title="发票类型" name="1">
              <van-button style="margin-right:5px;margin-bottom:5px;" :color="invoiceTypeIndex === index ? 'blue' : ''" plain hairline size="small" v-for="(item,index) in invoiceTypeOptions" :key="item.dictValue" @click="handleClick('invoiceType',item.dictValue,index)">{{ item.dictLabel }}</van-button>
            </van-collapse-item>
            <van-collapse-item title="发票状态" name="2">
              <van-button style="margin-right:5px;margin-bottom:5px;" :color="invoiceStatusIndex === index ? 'blue' : ''" plain hairline size="small" v-for="(item,index) in invoiceStatusOptions" :key="item.dictValue" @click="handleClick('invoiceStatus',item.dictValue,index)">{{ item.dictLabel }}</van-button>
            </van-collapse-item>
          </van-collapse>
        </div>
      </div>
      <div class="input-wrap">
        <van-cell-group>
          <van-field v-model="queryParams.custId" label="客户ID" placeholder="请输入客户ID" />
          <van-field v-model="queryParams.custName" label="客户名称" placeholder="请输入客户名称" />
          <van-field v-model="queryParams.contractName" label="合同名称" placeholder="请输入合同名称" />
          <van-field v-model="queryParams.invoiceNum" label="发票编号" placeholder="请输入发票编号" />
          <van-field v-model="queryParams.taxNum" label="纳税人识别号" placeholder="请输入纳税人识别号" />
          <van-field v-model="queryParams.mobile" label="电话" type="tel" placeholder="请输入电话" />
        </van-cell-group>
      </div>
      <div class="footer-btn-wrap">
        <van-button size="mini" type="primary" class="resetBtn" @click="resetQuery">重置</van-button>
        <van-button size="mini" type="info" class="submitbtn" @click="submitForm">搜索</van-button>
        <van-button size="mini" type="info" class="submitbtn" @click="cancel">取消</van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { Field, Popup, Icon, Button, Cell, CellGroup, CollapseItem, Divider, Collapse, Calendar } from 'vant';
export default {
  name: 'SearchPop',
  props: {
    show: Boolean
  },
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Divider.name]: Divider,
    [Calendar.name]: Calendar,
  },
  data() {
    return {
      activeNames: ['1'],
      showPop: this.show,
      invoiceTypeIndex: null,
      invoiceStatusIndex: null,
      queryParams: {},
      // 发票类型
      invoiceTypeOptions: [],
      // 合同状态
      contractStatusOptions: this.$store.state.dictOptions.contractStatus || [],
      invoiceStatusOptions: [],

    }
  },
  mounted() {
    //发票类型
    this.getDicts("accinvoice_invoice_type").then(response => {
      this.invoiceTypeOptions = response.data; // string
    });
    //发票状态
    this.getDicts("accinvoice_invoice_status").then(response => {
      this.invoiceStatusOptions = response.data; // string
    });
  },
  methods: {
    handleClick(type, prop, index) {
      switch (type) {
        case 'invoiceType':
          this.queryParams.invoiceType = prop
          this.invoiceTypeIndex = index
          break;
        case 'invoiceStatus':
          this.queryParams.invoiceStatus = prop
          this.invoiceStatusIndex = index
          break;
        default:
          console.log('handleClick', type, prop);
      }
    },
    resetQuery() {
      this.queryParams = {
        invoiceType: null,
        invoiceStatus: null,
        custId: null,
        custName: null,
        contractName: null,
        invoiceNum: null,
        taxNum: null,
        mobile: null
      }
      this.invoiceTypeIndex = null;
      this.invoiceStatusIndex = null;
    },
    submitForm() {
      this.$emit('handlequery', this.queryParams)
    },
    cancel() {
      this.showPop = false
      this.$emit('update:show', false)
    },
  },
}
</script>
<style lang="less">
.btn-wrap {
  width: 100%;
  box-sizing: border-box;

  .pop-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 36px;
    font-weight: bold;
    padding: 0;
    padding: 0 30px;
  }
  .type-list {
    margin-bottom: 40px;

    .title {
      font-size: 28px;
      font-weight: bold;
    }
    .list-wrapper {
      line-height: 0.5;
    }
  }
  .input-wrap {
    margin-top: 20px;
  }
  .select_list {
    .van-button {
      margin-top: 10px !important;
      margin-bottom: 10px !important;
    }
  }
}
.footer-btn-wrap {
  position: fixed;
  bottom: 100px;
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 30px;

  display: flex;
  justify-content: space-around;

  .van-button {
    width: 45%;
    height: 60px;
    font-size: 30px;

    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  }
}
</style>